<template>
  <div>
    <label class="control-label" v-if="label">{{ label }}:</label>
    <b-form-select
      @input="$emit('input', selected)"
      v-model="selected"
      :options="options"
      size="sm"
    />
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    label: {
      default: "Mês",
    },
    value: {},
  },
  data() {
    return {
      selected: moment().format("MM"),
      options: [
        { value: "01", text: "Janeiro" },
        { value: "02", text: "Fevereiro" },
        { value: "03", text: "Março" },
        { value: "04", text: "Abril" },
        { value: "05", text: "Maio" },
        { value: "06", text: "Junho" },
        { value: "07", text: "Julho" },
        { value: "08", text: "Agosto" },
        { value: "09", text: "Setembro" },
        { value: "10", text: "Outubro" },
        { value: "11", text: "Novembro" },
        { value: "12", text: "Dezembro" },
      ],
    };
  },

  watch: {
    value(value) {
      this.setMonth(value);
    },
  },

  created() {
    this.setMonth(this.value);
  },
  methods: {
    setMonth(value) {
      this.selected = value;
    },
  },
};
</script>